import { m } from '../../motif/m';

export const statsFontVars = {
  '--stats-stat-font-weight': m('--stats-font-weight'),
  '--stats-stat-font-size': m('--stats-font-size'),
  '--stats-stat-font-line-height': m('--stats-font-line-height'),
  '--stats-stat-supplementary-text-font-size': m('--stats-supplementary-text-font-size'),
  '--stats-stat-supplementary-text-font-weight': m('--stats-supplementary-text-font-weight'),
} as const;

export const statsYellowBackgroundVars = {
  '--stats-stat-color': m('--fg-color'),
  ...statsFontVars,
} as const;

export const statsBlackBackgroundVars = {
  '--stats-stat-color': m('--primary-v100'),
  ...statsFontVars,
} as const;

export const statsWhiteBackgroundVars = {
  '--stats-stat-color': m('--fg-color'),
  ...statsFontVars,
} as const;

export const statsGrayBackgroundVars = {
  '--stats-stat-color': m('--fg-color'),
  ...statsFontVars,
} as const;
